import React from 'react';

const InvoiceActionsBootstrap = ({
  onSaveDraft,
  onPublish,
  onDelete, // New prop for delete action
  isValid,
  hasUnsavedChanges = false,
  hasCriticalErrors = false,
  loading = false,
  showDeleteButton = false // New prop to control delete button visibility
}) => {

  return (
    <>
      <style>{`
        .actions-card {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
        }
        
        .actions-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }
        
        .actions-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .actions-right {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .btn-modern {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1.5rem;
          font-size: 0.875rem;
          font-weight: 600;
          border-radius: 8px;
          transition: all 0.2s ease;
          border: none;
          text-decoration: none;
          cursor: pointer;
        }
        
        .btn-save-draft {
          background: white;
          color: var(--bs-primary);
          border: 1px solid var(--bs-primary);
        }

        .btn-save-draft:hover:not(:disabled) {
          border-color: #44814E;
          background: #e0f2e9;
         }

        .btn-save-draft:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .btn-publish {
          background: #3b82f6;
          color: white;
          box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
        }
        
        .btn-publish:hover:not(:disabled) {
          background: #2563eb;
          box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
          transform: translateY(-1px);
        }
        
        .btn-publish:disabled {
          background: #94a3b8;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        
        .btn-delete {
          background: white;
          color: #ef4444;
          border: 1px solid #fca5a5;
        }
        
        .btn-delete:hover:not(:disabled) {
          background: #fee2e2;
          border-color: #ef4444;
          box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
        }
        
        .btn-delete:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid transparent;
          border-top: 2px solid currentColor;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .unsaved-indicator {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #f59e0b;
          font-size: 0.875rem;
          font-weight: 500;
        }
        
        .unsaved-icon {
          width: 16px;
          height: 16px;
          color: #f59e0b;
        }
        
        @media (max-width: 768px) {
          .actions-container {
            flex-direction: column;
            align-items: stretch;
          }
          
          .actions-right {
            justify-content: stretch;
          }
          
          .btn-modern {
            flex: 1;
            justify-content: center;
          }
        }
      `}</style>

      <div className="actions-card">
        <div className="actions-container">
          <div className="actions-left">
            <button
              type="button"
              className="btn-modern btn-save-draft"
              onClick={onSaveDraft}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner"></div>
              ) : (
                <i className="bi bi-save"></i>
              )}
              Spara utkast
            </button>

            {hasUnsavedChanges && (
              <div className="unsaved-indicator">
                <i className="bi bi-exclamation-circle-fill unsaved-icon"></i>
                <span>Osparade ändringar</span>
              </div>
            )}
          </div>

          <div className="actions-right">
            {showDeleteButton && (
              <button
                type="button"
                className="btn-modern btn-delete"
                onClick={onDelete}
                disabled={loading}
                title="Radera fakturautkast"
              >
                {loading ? (
                  <div className="spinner"></div>
                ) : (
                  <i className="bi bi-trash"></i>
                )}
                Radera utkast
              </button>
            )}

            <button
              type="button"
              className="btn-modern btn-publish"
              onClick={onPublish}
              disabled={!isValid || hasCriticalErrors || loading}
              title={
                !isValid ? 'Fyll i all nödvändig information innan publicering' :
                  hasCriticalErrors ? 'Åtgärda fel innan publicering' :
                    'Publicera faktura'
              }
            >
              {loading ? (
                <div className="spinner"></div>
              ) : (
                <i className="bi bi-send-check"></i>
              )}
              Publicera faktura
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceActionsBootstrap;